import { format, parseISO } from 'date-fns';

interface IDateFormatterProps {
  dateString: string;
  formatDate?: string;
  formatTime?: string;
  withTime?: boolean;
}

export const getDateFormat = (dateString: string, formatDate: string) => {
  if (!dateString) return '';
  const date = parseISO(dateString);

  const formatDateTemplate =
    formatDate === 'short' ? 'd MMM yyyy' : 'd MMMM yyyy';

  return format(date, formatDateTemplate);
};

export const getTimeFormat = (dateString: string, formatTime: string) => {
  if (!dateString) return '';

  const date = parseISO(dateString);

  const formatTimeTemplate = formatTime === '24' ? 'HH:mm:ss' : 'h:mm aaa';

  return format(date, formatTimeTemplate);
};

const DateFormatter = ({
  dateString,
  formatDate = 'short',
  formatTime = '24',
  withTime = false,
}: IDateFormatterProps) => {
  return (
    <>
      <span className="date">{getDateFormat(dateString, formatDate)}</span>
      {withTime && (
        <span className="time">{getTimeFormat(dateString, formatTime)}</span>
      )}
    </>
  );
};

export default DateFormatter;
